import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import CreateTask from '../../../shared/components/create-task';
import PreviousMeetingButtonMol from '../../../shared/components/previous-meeting-notes/components/PreviousMeetingButtonMol';
import { CSS_CONSTANTS } from '../../../shared/CSS/CSS_Constants';
import {
  MeetingData, MeetingSection, PrivateNoteData, TaskItems, TemplateData, Page,
} from '../../../shared/types/types';
import { detectDevice } from '../../../utils/analytics/functions';
import { CHROME_EXTENSION, ALL_PAGES } from '../../../utils/enums';
import ShareMeetingNotes from '../../meeting/share-meeting';
import TemplateEditBottomBar from '../../meeting/templates/components/TemplateEditBottomBar';
import MoreOptions from './more-options/MoreOptions';

const TransparentBackgroundContainer = styled.div`
  background-color: transparent;
  width: 100%;
`;

const BottomButtonMarginToSide = '25px';
interface PreviousBtnProps {
  isEnabled: boolean;
}
const PreviousBtnStyled = styled.div<PreviousBtnProps>`
  display: ${(props) => (props.isEnabled ? 'block' : 'none')};
  position: absolute;
  bottom: 10px;
  left: 10px;
`;

const ActionButtonStyled = styled.div`
  display: flex;
  position: absolute;
  bottom: 10px;
  right: ${BottomButtonMarginToSide};
  @media only screen and (min-width: ${CSS_CONSTANTS.MAX_WIDTH_FULL_PAGE}){
    right: calc((100vw - ${CSS_CONSTANTS.MAX_WIDTH_FULL_PAGE})*0.5 + ${BottomButtonMarginToSide} );
  }
`;

interface Props {
  isEditTemplateBottomBarEnabled: boolean
  meetingData: MeetingData,
  page: Page,
  taskItems: TaskItems,
  meetingSection: MeetingSection,
  setIsTemplatesOpen: Dispatch<SetStateAction<boolean>>,
  isCreateTaskModalOpen: boolean,
  setCreateTaskModalOpen: Dispatch<SetStateAction<boolean>>,
  setIsRecurringMeeting: Dispatch<SetStateAction<boolean>>,
  setSelectedTemplateToEdit: Dispatch<SetStateAction<TemplateData>>,
  selectedTemplateToEdit: TemplateData,
  privateNotes: PrivateNoteData[],
}

const BottomBar = ({
  meetingData,
  page,
  taskItems,
  meetingSection,
  setIsTemplatesOpen,
  isCreateTaskModalOpen,
  setCreateTaskModalOpen,
  setIsRecurringMeeting,
  privateNotes,
  isEditTemplateBottomBarEnabled,
  setSelectedTemplateToEdit,
  selectedTemplateToEdit,
}: Props) => {
  if (isEditTemplateBottomBarEnabled) {
    return (
      <TransparentBackgroundContainer>
        <TemplateEditBottomBar
          isEnabled={isEditTemplateBottomBarEnabled}
          meetingSection={meetingSection}
          setSelectedTemplateToEdit={setSelectedTemplateToEdit}
          selectedTemplateToEdit={selectedTemplateToEdit}
        />
      </TransparentBackgroundContainer>
    );
  }

  const isPreviousMeetingButtonEnabled = detectDevice(navigator.userAgent) === CHROME_EXTENSION;

  if (page === ALL_PAGES.ALL_NOTES) return null;

  if (meetingData.meetingId.length === 0) return null;

  if (page === ALL_PAGES.CURRENT_MEETING && meetingSection !== 'task') {
    return (
      <TransparentBackgroundContainer>
        <PreviousBtnStyled isEnabled={isPreviousMeetingButtonEnabled}>
          <PreviousMeetingButtonMol
            meetingData={meetingData}
            setIsRecurringMeeting={setIsRecurringMeeting}
          />
        </PreviousBtnStyled>
        <ActionButtonStyled>
          <ShareMeetingNotes
            taskItems={taskItems.tasks}
            privateNotes={privateNotes}
            closeDropdown={() => { }}
          />
          <MoreOptions
            meetingData={meetingData}
            meetingSection={meetingSection}
            isCreateTaskModalOpen={isCreateTaskModalOpen}
            setCreateTaskModalOpen={setCreateTaskModalOpen}
            setIsTemplatesOpen={setIsTemplatesOpen}
          />
        </ActionButtonStyled>
      </TransparentBackgroundContainer>
    );
  }
  return (
    <TransparentBackgroundContainer>
      <ActionButtonStyled>
        <CreateTask
          meetingData={meetingData}
          isOpen={isCreateTaskModalOpen}
          setIsOpen={setCreateTaskModalOpen}
        />
      </ActionButtonStyled>
    </TransparentBackgroundContainer>
  );
};

export default BottomBar;
